const categories = ['time_of_arrival', 'service', 'product_defects', 'non_delivery', 'no_notifications', 'other']
export default categories
